module.exports = __webpack_public_path__ + "static/media/gocon2025.27b02a18.png";